export const DESCRIPTION = 'hs_description';